import { AfterViewInit, Component, OnDestroy, OnInit, output, viewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {Subject, Subscription} from 'rxjs';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {takeUntil, tap} from 'rxjs/operators';
import {Customer, CustomerSearchAPI} from '../../master-data/master-data.model';
import {CustomerService} from '../customer-service';
import {PAGINATOR_ITEMS_PER_PAGE, PAGINATOR_NEXT_PAGE, PAGINATOR_PREV_PAGE} from '../../../locale/consts.en';


@Component({
    selector: 'app-customer-selection',
    templateUrl: './customer-selection.component.html',
    styleUrls: ['./customer-selection.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomerSelectionComponent implements OnInit, AfterViewInit, OnDestroy {
  private customerService = inject(CustomerService);
  dialog = inject(MatDialog);

  readonly paginator = viewChild(MatPaginator);
  readonly sort = viewChild(MatSort);
  readonly customerSelected = output<Customer>();

  subscription: Subscription;
  displayedColumns = ['name', 'place', 'nip'];
  dataSource: MatTableDataSource<Customer>;
  selectedRowIndex: number;
  pageNumber = 0;
  pageSize = 10;
  totalNumberOfItems: number;
  searchText = '';
  private numberOfPages: number;
  private destroyed$ = new Subject();



  constructor() {
    this.dataSource = new MatTableDataSource();
    this.subscription = this.customerService.getCostumersBySearch(this.searchText, this.pageNumber, this.pageSize).subscribe(
      customers => {
        this.loadCustomers(customers);
      }
    );

  }


  ngOnInit() {
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'place': return item.city;
        default: return item[property];
      }
    };
    this.dataSource.sort = this.sort();

    // needed to filter nested data elements
    // https://stackoverflow.com/questions/49833315/angular-material-2-datasource-filter-with-nested-object
    this.dataSource.filterPredicate = (data, filter: string) => {
      const accumulator = (currentTerm, key) => {
        let term;
        if (key === 'address') {
          term = currentTerm + data.city ;
        } else {
          term = currentTerm + data[key];
        }
        return term;
      };
      const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
      // Transform the filter by converting it to lowercase and removing whitespace.
      const transformedFilter = filter.trim().toLowerCase();
      return dataStr.indexOf(transformedFilter) !== -1;
    };

  }

  ngAfterViewInit() {
    // eslint-disable-next-line no-underscore-dangle
    const paginator = this.paginator();
    paginator._intl.itemsPerPageLabel = PAGINATOR_ITEMS_PER_PAGE;
    // eslint-disable-next-line no-underscore-dangle
    paginator._intl.nextPageLabel = PAGINATOR_NEXT_PAGE;
    // eslint-disable-next-line no-underscore-dangle
    paginator._intl.previousPageLabel = PAGINATOR_PREV_PAGE;

    paginator.page
      .pipe(
        takeUntil(this.destroyed$),
        tap(() => this.loadSearchPage())
      )
      .subscribe();
  }

  selectCustomer(customer: Customer, i: number) {
    this.selectedRowIndex = i;
    this.customerSelected.emit(customer);
  }


  applyFilter(filterValue: string) {
    this.searchText = filterValue;
    this.customerService.getCostumersBySearch(this.searchText, this.pageNumber, this.pageSize).subscribe(
      customers => {
        this.loadCustomers(customers);
      }
    );
  }

  ngOnDestroy(): void {
    if (this.subscription != null) {
      this.subscription.unsubscribe();
    }
    this.destroyed$.complete();
  }

  private loadCustomers(response: CustomerSearchAPI) {
    this.dataSource.data = response.content;
    this.totalNumberOfItems = response.totalElements;
    this.pageSize = response.size;
    this.numberOfPages = response.totalPages;
  }

  private loadSearchPage() {
    this.customerService.getCostumersBySearch(this.searchText,  this.paginator().pageIndex, this.paginator().pageSize).subscribe(
      customers => {
        this.loadCustomers(customers);
        this.customerSelected.emit(null);
      }
    );
  }
}
